export default function CashbackPrograms() {
  const cashbackPrograms = [
    {
      casino: "MONRO",
      cashback: "20%",
      frequency: "Еженедельно",
      minLoss: "5 000 ₽",
      wager: "x3",
      maxCashback: "50 000 ₽",
      url: "https://mnr-blse21.com/c831ca2e4",
      features: ["Без ограничений по играм", "Быстрое начисление", "VIP-бонусы"]
    },
    {
      casino: "ROX",
      cashback: "15%",
      frequency: "Ежедневно",
      minLoss: "1 000 ₽",
      wager: "x5",
      maxCashback: "25 000 ₽",
      url: "https://rox-media4.com/c72ce8213",
      features: ["Ежедневные выплаты", "Низкий порог", "Все игры"]
    },
    {
      casino: "1GO",
      cashback: "18%",
      frequency: "Еженедельно",
      minLoss: "3 000 ₽",
      wager: "x1",
      maxCashback: "100 000 ₽",
      url: "https://1go-blrs10.com/c8100c010",
      features: ["Минимальный вейджер", "Высокий лимит", "Live-казино"]
    }
  ];

  const loyaltyPrograms = [
    {
      casino: "Fugu",
      levels: 10,
      benefits: "Персональный менеджер, увеличенные лимиты, эксклюзивные бонусы",
      cashback: "До 25%",
      url: "https://fugu-way-one.com/c763d5df9"
    },
    {
      casino: "STARDA",
      levels: 8,
      benefits: "Ускоренный вывод, бонусы на день рождения, турниры",
      cashback: "До 20%",
      url: "https://strd-blit10.com/c3369b683"
    },
    {
      casino: "DRIP",
      levels: 12,
      benefits: "Кешбэк без вейджера, приоритетная поддержка, VIP-подарки",
      cashback: "До 30%",
      url: "https://drp-blrs21.com/c4cea69e8"
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 animate-on-scroll opacity-0">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Лучшие программы кешбэка в казино онлайн
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Возвращайте проигранное — получайте до 30% от проигрышей обратно на счет
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6 mb-16">
          {cashbackPrograms.map((program, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:scale-105"
            >
              <div className="bg-gradient-to-br from-purple-500 to-purple-600 p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">{program.casino}</h3>
                <div className="text-4xl font-bold mb-1">{program.cashback}</div>
                <div className="text-purple-100">{program.frequency}</div>
              </div>

              <div className="p-6 space-y-4">
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <div className="text-gray-500 mb-1">Мин. проигрыш</div>
                    <div className="font-semibold text-gray-900">{program.minLoss}</div>
                  </div>
                  <div>
                    <div className="text-gray-500 mb-1">Вейджер</div>
                    <div className="font-semibold text-gray-900">{program.wager}</div>
                  </div>
                </div>

                <div>
                  <div className="text-gray-500 text-sm mb-1">Макс. кешбэк</div>
                  <div className="text-xl font-bold text-purple-600">{program.maxCashback}</div>
                </div>

                <div className="pt-4 border-t border-gray-100">
                  <div className="text-sm font-semibold text-gray-900 mb-3">Преимущества:</div>
                  <ul className="space-y-2">
                    {program.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-green-500"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <a
                  href={program.url}
                  target="_blank"
                  rel="nofollow sponsored noopener noreferrer"
                  className="block w-full py-4 bg-gradient-to-r from-purple-500 to-purple-600 text-white text-center font-bold rounded-xl hover:from-purple-600 hover:to-purple-700 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer mt-6"
                >
                  Получить кешбэк
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mb-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            VIP-программы лояльности казино онлайн
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            {loyaltyPrograms.map((program, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-6 border border-amber-200 hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-center justify-between mb-4">
                  <h4 className="text-xl font-bold text-gray-900">{program.casino}</h4>
                  <div className="bg-amber-500 text-white px-3 py-1 rounded-full text-sm font-semibold whitespace-nowrap">
                    {program.levels} уровней
                  </div>
                </div>
                <p className="text-gray-700 mb-4 text-sm leading-relaxed">{program.benefits}</p>
                <div className="flex items-center justify-between mb-4">
                  <span className="text-gray-600 text-sm">Кешбэк:</span>
                  <span className="text-lg font-bold text-orange-600">{program.cashback}</span>
                </div>
                <a
                  href={program.url}
                  target="_blank"
                  rel="nofollow sponsored noopener noreferrer"
                  className="block w-full py-3 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-center font-semibold rounded-lg hover:from-amber-600 hover:to-orange-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Узнать больше
                </a>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-2xl p-8 border border-purple-100">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">
            Кешбэк vs Бонус на депозит: что выгоднее?
          </h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-purple-500 rounded-xl flex items-center justify-center">
                  <i className="ri-refresh-line text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900">Кешбэк</h4>
              </div>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-1"></i>
                  <span className="text-gray-700">Регулярные выплаты (еженедельно/ежемесячно)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-1"></i>
                  <span className="text-gray-700">Низкий вейджер (x1-x5) или без него</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-1"></i>
                  <span className="text-gray-700">Подходит для постоянных игроков</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-1"></i>
                  <span className="text-gray-700">Возврат реальных денег</span>
                </li>
              </ul>
            </div>
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center">
                  <i className="ri-gift-line text-2xl text-white"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-900">Бонус на депозит</h4>
              </div>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-1"></i>
                  <span className="text-gray-700">Большая сумма сразу (до 500%)</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-1"></i>
                  <span className="text-gray-700">Увеличивает игровой банкролл</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-1"></i>
                  <span className="text-gray-700">Идеален для новичков</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-green-500 mt-1"></i>
                  <span className="text-gray-700">Требует отыгрыша (x30-x45)</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-6 p-4 bg-white rounded-xl">
            <p className="text-gray-700 text-center">
              <strong>Вывод:</strong> Для регулярных игроков кешбэк выгоднее на 35%, так как не требует сложного отыгрыша. Бонусы на депозит лучше использовать для первого знакомства с казино онлайн.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}